import { z } from 'zod';

export const impactShopStockStatusSchema = z.enum(['IN_STOCK', 'OUT_OF_STOCK', 'NOT_CONTROLLED']);

export type ImpactShopStockStatus = z.infer<typeof impactShopStockStatusSchema>;

export function getImpactShopAvailableStockBalance(
  stockOverview: { eligibleStock: bigint; reservedStock: bigint } | null | undefined,
): bigint | undefined {
  return stockOverview ? stockOverview.eligibleStock - stockOverview.reservedStock : undefined;
}

export function deriveImpactShopStockStatus(
  stockControlled: boolean,
  projectStockBalances: Array<bigint | null | undefined>,
): ImpactShopStockStatus {
  if (!stockControlled) return 'NOT_CONTROLLED';
  return projectStockBalances.length > 0 && projectStockBalances.every(balance => (balance ?? BigInt(0)) > BigInt(0))
    ? 'IN_STOCK'
    : 'OUT_OF_STOCK';
}

export function deriveImpactShopStockAvailability(
  stockControlled: boolean,
  projectStockBalances: Array<bigint | null | undefined>,
) {
  const stockStatus = deriveImpactShopStockStatus(stockControlled, projectStockBalances);
  return { stockStatus, isAvailable: stockStatus !== 'OUT_OF_STOCK' };
}
